import lang from '@/lang/careers';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en, 'careers');
  const subtitle = store.$i18n.t('jumbotron.subtitle');
  const title = store.$i18n.t('title');
  const description = store.$i18n.t('description');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'expanded' });
  store.commit('pageContent/setHead', { title, description });
};
